import useViewportSize from "./useViewportSize";

export type SizeClass = "desktop" | "handheld";

export default function useSizeClass(): SizeClass {
  return useViewportSize()[0] >= 768 ? "desktop" : "handheld"; // matches $smallBreak in index.scss
}
